import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup } from '@angular/forms';
import { ConfirmDialogComponent } from '../../dialog/confirm-dialog/confirm-dialog.component';
import {
  SubscriptionCouponsEditComponent
} from 'src/app/components/subscription-coupons/subscription-coupons-edit/subscription-coupons-edit.component';
import { SubscriptionCouponsService } from 'src/app/services/subscription-coupons.service';
import { SubscriptionCoupon } from 'src/app/classes/SubscriptionCoupon';

@Component({
  selector: 'app-coupon-list',
  styleUrls: ['./subscription-coupons-list.component.scss'],
  templateUrl: './subscription-coupons-list.component.html',
})
export class SubscriptionCouponsListComponent implements OnInit {

  public coupons: SubscriptionCoupon[];
  public errorMessage: string;
  private currentDialog = null;

  constructor(
    private couponService: SubscriptionCouponsService,
    private modalService: NgbModal
  ) {
  }

  ngOnInit(): void {
    this.refreshList();
  }

  refreshList(): void {
    this.couponService.getAll().subscribe({
      next: (coupons) => {
        this.coupons = coupons;
      },
      error: (error) => this.errorMessage = error.error.error
    });
  }

  openEditModal(coupon: SubscriptionCoupon): void {
    this.currentDialog = this.modalService.open(SubscriptionCouponsEditComponent,
      {
        scrollable: true,
        windowClass: 'modal-coupon-edit',
        size: 'md',
        centered: true,
      });

    this.currentDialog.componentInstance.coupon = coupon;

    this.currentDialog.result.then(
      (result) => {
        if (result instanceof FormGroup) {
          const editedCoupon = new SubscriptionCoupon(result.value);
          if (result.value.id) {
            this.couponService.edit(editedCoupon).subscribe({
              next: () => this.refreshList(),
              error: (error) => this.errorMessage = error.error.error
            });
          } else {
            this.couponService.add(editedCoupon).subscribe({
              next: () => this.refreshList(),
              error: (error) => this.errorMessage = error.error.error
            });
          }
        }
      },
      (error) => {
        console.log('Dialog close error: ' + error);
      }
    );
  }

  openDeleteConfirmModal(coupon: SubscriptionCoupon): void {
    this.currentDialog = this.modalService.open(ConfirmDialogComponent,
      {
        scrollable: true,
        windowClass: 'modal-coupon-delete-confirm',
        size: 'md',
        centered: true,
      });

    this.currentDialog.componentInstance.message =
      'Are you sure that you want delete coupon with id ' + coupon.id + '?';

    this.currentDialog.result.then((result) => {
      if (result.status === 'confirmed') {
        this.couponService.delete(coupon.id).subscribe({
          next: () => this.refreshList(),
          error: (error) => this.errorMessage = error.error.error
        });
      }
    }, (error) => {
      console.log('Dialog close error: ' + error);
    });
  }
}
